module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/religiao/religiao.component.css
// module id = ./src/app/religiao/religiao.component.css
// module chunks = main